import { useQuery } from '@tanstack/react-query';

import type { SlowSection } from '@/types';

import axiosInstance from '@/utils/api/axios-instance';

const useGetSlowSections = () => {
  return useQuery<SlowSection[]>({
    queryKey: ['slowSections'],
    queryFn: async () => {
      const response = await axiosInstance.get('slow-sections');

      return response.data;
    },
    retry: false,
    gcTime: Infinity,
    staleTime: Infinity,
  });
};

export default useGetSlowSections;
